var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsBro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.58 119.45s-52.13-29.16-111.94-7-97.93 79.8-130 125.71-27.19 99 10.43 129.24 71.72.9 130.33 9.16 72.88 19.26 126.89-5.45 76-101 47.66-165-73.37-86.66-73.37-86.66z",
    fill: "#92e3a9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.58 119.45s-52.13-29.16-111.94-7-97.93 79.8-130 125.71-27.19 99 10.43 129.24 71.72.9 130.33 9.16 72.88 19.26 126.89-5.45 76-101 47.66-165-73.37-86.66-73.37-86.66z",
    fill: "#fff",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.67 428.55c0 3.92-77.91 7.1-174 7.1s-174-3.18-174-7.1 77.9-7.11 174-7.11 174 3.18 174 7.11z",
    fill: "#92e3a9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.67 428.55c0 3.92-77.91 7.1-174 7.1s-174-3.18-174-7.1 77.9-7.11 174-7.11 174 3.18 174 7.11z",
    fill: "#fff",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M399.91 356.9a21 21 0 00-4.74 9.84l-9.5 5.33v-25.19l.18.26L401 336.05c1.91.3 9.26 1.14 16-2.47 7.72-4.19 13.4-18.58 13.4-18.58s-18.53-2.09-24.81 5.68a21.53 21.53 0 00-5.15 14.5L385.67 346v-18.6a20.57 20.57 0 0011.25-13.58c2.69-10.47-11.66-31.1-11.66-31.1s-14.95 21.23-12 32c2.53 9.12 9.34 12 11.37 12.68v40.35L374 358.88c.24-2.12.43-8.77-5.49-15.44-7.18-8.07-26.31-7.47-26.31-7.47s8.07 16.14 15 21.53c6 4.7 14.3 2.78 16.29 2.22l11.22 9.35v12.26H368l6.8 42.5h20.4l6.8-42.5h-16.33v-8.11l10.44-5.85c2.54.7 9.64 2.16 16.36-1.2C420.84 362 427.71 353 427.71 353s-20.03-5.07-27.8 3.9z",
    fill: "#92e3a9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M399.91 356.9a21 21 0 00-4.74 9.84l-9.5 5.33v-25.19l.18.26L401 336.05c1.91.3 9.26 1.14 16-2.47 7.72-4.19 13.4-18.58 13.4-18.58s-18.53-2.09-24.81 5.68a21.53 21.53 0 00-5.15 14.5L385.67 346v-18.6a20.57 20.57 0 0011.25-13.58c2.69-10.47-11.66-31.1-11.66-31.1s-14.95 21.23-12 32c2.53 9.12 9.34 12 11.37 12.68v40.35L374 358.88c.24-2.12.43-8.77-5.49-15.44-7.18-8.07-26.31-7.47-26.31-7.47s8.07 16.14 15 21.53c6 4.7 14.3 2.78 16.29 2.22l11.22 9.35v12.26H368l6.8 42.5h20.4l6.8-42.5h-16.33v-8.11l10.44-5.85c2.54.7 9.64 2.16 16.36-1.2C420.84 362 427.71 353 427.71 353s-20.03-5.07-27.8 3.9z",
    fill: "#fff",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 117.99,
    y: 116.01,
    width: 252.15,
    height: 167.53,
    rx: 11.66,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.99,
    y: 116.01,
    width: 252.15,
    height: 167.53,
    rx: 11.66,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.84 209.67h29.5v16.55h-29.5zM194.84 229.21h29.5v16.55h-29.5zM227.34 209.67h29.5v16.55h-29.5zM259.85 190.12h29.5v16.55h-29.5zM259.85 170.57h29.5v16.55h-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M259.85 134.44h29.5v13.58h-29.5zM227.34 134.44h29.5v13.58h-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M227.34 229.21h29.5v16.55h-29.5zM227.34 151.02h29.5v16.55h-29.5zM227.34 170.57h29.5v16.55h-29.5zM227.34 190.12h29.5v16.55h-29.5zM259.85 229.21h29.5v16.55h-29.5zM127.88 151.02h31.45v16.55h-31.45zM127.88 190.12h31.45v16.55h-31.45zM127.88 209.67h31.45v16.55h-31.45zM127.88 170.57h31.45v16.55h-31.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M324.86 134.44h31.45v13.58h-31.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.88 229.21h31.45v16.55h-31.45zM292.35 151.02h29.5v16.55h-29.5zM259.85 209.67h29.5v16.55h-29.5zM292.35 209.67h29.5v16.55h-29.5zM292.35 170.57h29.5v16.55h-29.5zM292.35 190.12h29.5v16.55h-29.5zM292.35 229.21h29.5v16.55h-29.5zM259.85 151.02h29.5v16.55h-29.5zM324.86 229.21h31.45v16.55h-31.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M292.35 134.44h29.5v13.58h-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M324.86 209.67h31.45v16.55h-31.45zM292.35 248.76h29.5v17.49h-29.5zM324.86 190.12h31.45v16.55h-31.45zM227.34 248.76h29.5v17.49h-29.5zM259.85 248.76h29.5v17.49h-29.5zM324.86 170.57h31.45v16.55h-31.45zM324.86 248.76h31.45v17.49h-31.45zM127.88 248.76h31.45v17.49h-31.45zM324.86 151.02h31.45v16.55h-31.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M127.88 134.44h31.45v13.58h-31.45zM162.33 134.44h29.5v13.58h-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M162.33 209.67h29.5v16.55h-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M194.84 134.44h29.5v13.58h-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.84 170.57h29.5v16.55h-29.5zM162.33 229.21h29.5v16.55h-29.5zM194.84 151.02h29.5v16.55h-29.5zM162.33 151.02h29.5v16.55h-29.5zM194.84 190.12h29.5v16.55h-29.5zM162.33 190.12h29.5v16.55h-29.5zM162.33 248.76h29.5v17.49h-29.5zM162.33 170.57h29.5v16.55h-29.5zM194.84 248.76h29.5v17.49h-29.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.76,
    cy: 121.06,
    r: 4.25,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4 121.06a4.26 4.26 0 10-4.25 4.25 4.25 4.25 0 004.25-4.25zM141.84 123.83h0a2.23 2.23 0 01-2.23-2.23v-15.08a2.23 2.23 0 012.23-2.24h0a2.24 2.24 0 012.24 2.24v15.08a2.23 2.23 0 01-2.24 2.23z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36 123.83h0a2.23 2.23 0 01-2.23-2.23v-15.08a2.23 2.23 0 012.23-2.24h0a2.24 2.24 0 012.24 2.24v15.08a2.23 2.23 0 01-2.24 2.23zM337.92 121.06a4.26 4.26 0 10-4.25 4.25 4.25 4.25 0 004.25-4.25z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.05,
    cy: 121.06,
    r: 4.25,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.74 123.83h0a2.23 2.23 0 01-2.23-2.23v-15.08a2.23 2.23 0 012.23-2.24h0a2.24 2.24 0 012.24 2.24v15.08a2.23 2.23 0 01-2.24 2.23zM348.27 123.83h0a2.23 2.23 0 01-2.27-2.23v-15.08a2.24 2.24 0 012.24-2.24h0a2.23 2.23 0 012.23 2.24v15.08a2.23 2.23 0 01-2.2 2.23z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.72,
    cy: 121.06,
    r: 4.25,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.1,
    cy: 121.06,
    r: 4.25,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.79 123.83h0a2.23 2.23 0 01-2.23-2.23v-15.08a2.23 2.23 0 012.23-2.24h0a2.24 2.24 0 012.24 2.24v15.08a2.23 2.23 0 01-2.24 2.23zM252.31 123.83h0a2.23 2.23 0 01-2.23-2.23v-15.08a2.23 2.23 0 012.23-2.24h0a2.24 2.24 0 012.24 2.24v15.08a2.23 2.23 0 01-2.24 2.23z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M148.3 172.01l-14.88 13.12M138 172.01l10.3 12.24M312.99 153.35l-14.88 13.11M302.69 153.35l10.3 12.24M215.48 153.35l-14.89 13.11M205.17 153.35l10.31 12.24M347.03 152.98l-14.89 13.12M336.72 152.98l10.31 12.24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.79 308.18s-3.09 17.34-3.56 27.32 1.9 17.1 2.85 27.08 7.12 48.22 7.12 51.31a12.45 12.45 0 01-2.37 8.08c-1.9 2.61-8.08 5-7.6 5.93s3.32 2.38 8.31.72 5.23-3.33 7.13-3.33 5.94-1.19 5.22-4-4.24-8.78-4-19.24c.47-24.23-.72-66-.72-66l7.6-23.28z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09 421.58l-.26.39c-1.9 2.61-8.08 5-7.6 5.93s3.32 2.38 8.31.72 5.23-3.33 7.13-3.33 5.94-1.19 5.22-4c-.22-.9-.73-2.11-1.31-3.67a51.65 51.65 0 01-7.24 4.62c-1.13.42-2.81-.05-4.25-.66zM312.86 205.78s-1.12-3.82-1.89-7.22 5-4.87 11.33-5.5 15.28 4.09 17.92 11.59.42 35.26.69 41.32.87 22.85-5.28 23.9-12.62 1.46-18-9.08.52-38.26 1.16-43.83-5.61-10.37-5.61-10.37z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38 197.9s-.42 6.36 3.82 9.75 9.74 11.44 9.74 17.8M334.44 215.28s3 11 .42 20.34",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81 311.16s-5 22.6-.39 42.13c1.26 5.34 20.69 53.24 22.22 60.9s1.53 14.56 4.6 17.24 5 1.53 3.44-7.28a58.16 58.16 0 00-5-14.17s-5.75-36.77-6.52-44.81-5.36-17.62-5.36-17.62l7.28-31.41z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.69 420c-.37 2-1.17 3.73-2.84 3.4a4.05 4.05 0 01-3.2-3.13c.75 5.06 1.36 9.23 3.59 11.17 3.06 2.68 5 1.53 3.44-7.28a37.52 37.52 0 00-.99-4.16zM324.41 418h-.09c0 .18.05.36.08.53a5.3 5.3 0 01.01-.53z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74 233.69a9.8 9.8 0 00-5.86 4.08c-2 3.31-20.63 17.32-22.41 18.84s-1.53 9.17 3 9.17 19.87-11.71 19.87-11.71 4.58-5.61 6.11-10.7 2.6-9.17-.71-9.68z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83 220.71c-1.78 0-3.54 4.18-3.54 4.18l-1.68.25c1.51-1.79 3.44-4.43 3.44-4.43 1.52-2.55 1-6.37 0-6.11s-7.64 2.8-8.66 4.07-4.08 11.46-5.09 12.48-17.83 22.41-19.61 27 3.05 10.19 7.13 7.39 7.64-11.47 9.18-17.54 7.9-17.58 7.9-17.58 1.48-1.2 3-2.54a46 46 0 004.9-1.53c1-.51 3.82-4.08 3.82-4.08s.99-1.56-.79-1.56z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.55 212.47l-5.16 8.18a2.12 2.12 0 00.45 2.77l2.35 1.93a2.12 2.12 0 003.1-.46l5.47-8.11a2.13 2.13 0 00-.49-2.89l-2.66-2a2.12 2.12 0 00-3.06.58z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.22 216.19s-1.49 9.55-1.91 13.2-.31 4.44 2.76 4.79 8.14 1.91 10.13 6.61-9.57 18.93-13 22-4.96 7.21-4.2 10.45 9.73 13.72 9.34 24.35-13.24 41.62-13.24 41.62-17.13-6.94-29.5-4.62c0 0 5.84-41.06 9.31-51.88s7-16.68 6.72-19-4.6-9.09-3.55-14.81 4.74-10.73 6.46-13.84 5.41-3.07 6.75-2.92 3.24.57 4.19-.88 1.8-8.93 1.8-8.93z",
    fill: "#92e3a9",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M307.32 257.65l7.62 5.51M314.37 281.47s-7.64 14.58-9.37 25M305.35 296.4s-2.09 9-3.13 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.48 238s-2.55 1.28-5.35 5.61-5.35 11.71-4.84 13.49 5.35-1.27 5.35-1.27 5.11 22.91 9.67 21.14c9.17-3.57-3.05-37.18-3.05-37.18s0-1.26-1.78-1.79zM315.79 241.13c-5.18-1.28-3.8-6.22-2.51-9h.05c1.35.16 3.24.57 4.19-.88s1.8-8.93 1.8-8.93l7.9-6.09s-1.49 9.55-1.91 13.2-.31 4.44 2.76 4.79c0-.04-4.9 8.78-12.28 6.91z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23 197.49a14.69 14.69 0 00.83 8.07c1.71 3.7 9 8 9 8s2.87-3 3.29.19-.93 6.31-3.06 6.26-2.44-2.42-2.44-2.42a14.56 14.56 0 01-7.86 5.71c-5.66 1.87-8.54 1.54-9.21-2.81s.11-9.33 2.09-14.74 6.57-8.16 7.36-8.26zM341.33 234.71l.26-4.07a41.25 41.25 0 003.56-3.57c1.53-1.78 2.55-4.33 3.82-3.31s-1.78 4.08-1.78 4.08l-.26 2 5.1-1.52s4.84-4.84 5.09-3.57-2.55 5.6-4.58 7.9-8.15 3-8.15 3-.26 20.37-.26 26.49-.76 13-2.54 14.26-7.39.25-6.11-9.68 5.85-32.01 5.85-32.01z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M330.64 255.85l-1.53-4.84"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.4 195.53s4.59 5.82 5.06 7.1a24.09 24.09 0 01.82 2.85l3 2.22a.85.85 0 01.16 1.23l-2.27 2.79s2.11 7 2 8-7.44 3.49-7.44 3.49l-.68 5.36-13.9-.18-.05-9.93-5.55-13s4.97-9.38 18.85-9.93z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 215.12l1.87-.2a6.25 6.25 0 002.94 4",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 195.86s-5.25.25-5.22 7.52 7.39 14 7.79 15.07 4.34.57 7.11-.46a7.27 7.27 0 003.79-2.87s-2.65-3.86-2.11-5 3.38-.05 3.38-.05a6.74 6.74 0 001.68-1.35c.48-.67 3.05-3.56 1.27-5.08s-4.55-2.44-3.32-4.36 5.63-3.79 4.34-7.92-4.17-4-6.57-2.65-3.06-3-7.73-.53-5.98 6.08-4.41 7.68z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64 210.1a9.06 9.06 0 000 2.32M189.74 198.42s-1 1.85-5 5.44a9.48 9.48 0 00-2.86 4.73M190.68 202.09s-4.07 5.52-6.21 7.16",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69 196.14a55.16 55.16 0 0013 4.36s-6.41-4.34-12.61-5.42c-.57-.08-.88.81-.39 1.06z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5 229l7.64-19.56s-3-4.93-3-6.42 4.78-6.85 4.78-6.85.39-2.91 2.47-1.52a4.22 4.22 0 011.82 3.74 38.62 38.62 0 012.61 4.23c.48 1.16-4.06 7.61-4.06 7.61S242 228 240 234.11s-2.5 7.38-3.83 9.17-7.65-1.36-7.65-1.36z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 417.72l12.43 4.52a2.21 2.21 0 011.3 3 1.47 1.47 0 01-.83.73c-1.58.57-18 6.2-22.79 4.17a3 3 0 01-1.65-2.63 83.13 83.13 0 011.21-11s6.1 2.89 10.33 1.21z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.32 425.25a2 2 0 00.05-1.69c-3.44 1.67-10.75 4.8-17.41 4.92a27.12 27.12 0 01-7.88-.67 3.1 3.1 0 001.62 2.34c4.82 2 21.21-3.6 22.79-4.17a1.47 1.47 0 00.83-.73z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.11 413.94s-1.12 10.31-.52 11.33 2.39 1.71 5.47 1.51a4.5 4.5 0 004.2-3.17c.28-.74-.44-7.48-.46-8.66s-8.69-1.01-8.69-1.01z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29 421.68c-.95 1.83-2.16 3-5.3 3.06a8 8 0 01-4.58-1.22 4.89 4.89 0 00.18 1.75c.61 1 2.39 1.71 5.47 1.51a4.5 4.5 0 004.2-3.17 8.06 8.06 0 00.03-1.93zM202.22 295.31a41.76 41.76 0 01-9.17 3.27l-27.57-6.37s-1.83 15.46-1.78 18.12 1 50.53 1 50.53l-3.76 53.8a4.59 4.59 0 004.31 2.58 12.87 12.87 0 005.3-1.17l11.82-56 2.63 59.45s1.63 1.57 5.35 1.49a6.18 6.18 0 005.26-3.29s1.83-23 4.56-39.46 3.06-61.77 3.06-61.77z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 303.42a56.27 56.27 0 0011 1.27M165.78 300.45s1.28 1.7 4.67 1.7M193.75 403.42s2.54-30.51 4.24-52.54a286.5 286.5 0 00.42-39s4.24-4.66 1.27-12.71M193.75 406.81l-1.27 9.75M182.34 360.08l-3.02-39.94-7.05-6.78",
    fill: "none",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57 273.39a2.2 2.2 0 00-.87-2.5c-3.06-2.07-10.48-6.33-12.85-.72a36.09 36.09 0 00-1.44 6.72c-.66 4.49-.42 34.89-.39 38a2.07 2.07 0 01-.06.5c-.26 1.19-1.35 6.39-.59 9.49.85 3.53 2.48 6.25 5.25 7s4.28-2.45 3.85-4.41.6-3.48.17-5.44c-.35-1.58-1.85-5.71-2.42-7.24a2.26 2.26 0 01-.1-1.18c.78-4 5.15-26.43 5.48-27.51s2.89-9.22 3.97-12.71z",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.79 325.55s3.53 2.47 3.94 4.75M156.91 323.5s2.8 1.83 3.55 3.27",
    fill: "none",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.42 321.43l1 1.38s.5 5.5 2.06 4.68.64-7.49.64-7.49-.79-1.63-3.23-5.52",
    fill: "#fff",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24 315.68a10.48 10.48 0 01-.14 6 47.61 47.61 0 01-3 4.9 46.53 46.53 0 014.11 4.48",
    fill: "none",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 237.31l-9.07 33.33s7.59 6.15 17 6L173 245s-6.78-15.23-14-7.69z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 226.38S160.68 233 159.43 236c-1 2.5 2.06 20.2 2.12 23.31s2.72 29.83 3.44 35 18 7.37 24.58 5.38 12.69-2.75 12.65-4.41-.92-15.72-.56-18.41 3.15-22.87 3.15-22.87l25.11-5.2s1.16-.7 1.19-5.24a122.85 122.85 0 00-.66-12.83 28.9 28.9 0 01-9.94.62c-6.06-.54-13.24-2.17-14.52-1.81s-10-1.46-12.87-1.82c-3.99-.54-14.12-3.92-19.12-1.34z",
    fill: "#263238",
    stroke: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M162.82 275.03l-3.49-29.27M160.28 258.5l-1.7-3.81M204.81 253.95l-9.79 1.58M202.65 254.69l-7.2 6.78M224.68 232.23s-6.78 10.17-23.3 14"
  }))));
}
export default "/_next/static/media/Events-bro.c840b215e10c224bcf82a227f9b5e83b.svg";
export { SvgEventsBro as ReactComponent };